import type { VideoCategoryShallow } from "@brookbush/types";

import { LayoutGroup } from "framer-motion";

import VideosCatalogueItem from "./VideosCatalogueItem";
import Accordion from "~/components/Accordion";

const VideosCatalogue = ({
	shallowCategories,
}: {
	shallowCategories: VideoCategoryShallow[];
}) => {
	return (
		<div className="flex flex-col gap-2">
			<LayoutGroup>
				{shallowCategories.map((category) => (
					<Accordion key={category.slug}>
						<VideosCatalogueItem
							shallowCategories={shallowCategories}
							category={category}
							parentSlugs={[]}
						/>
					</Accordion>
				))}
			</LayoutGroup>
		</div>
	);
};

export default VideosCatalogue;
